import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { DhProfileConfigService } from '../services/dh-profile-config.service';

/**
 * Blocks access to a level intro page unless landing.enabled is true on the
 * corresponding JSON config. Reads the required level from route.data.level.
 * If disabled (or missing), redirects to the appropriate DH landing.
 */
@Injectable({ providedIn: 'root' })
export class LandingEnabledGuard implements CanActivate {
  constructor(
    private dhConfig: DhProfileConfigService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    const level = Number(route.data['level']);
    if (!level) return Promise.resolve(true);

    const isNl = (typeof window !== 'undefined' && window.location.pathname.startsWith('/doublehealixprofiel'));
    const landingUrl = isNl ? '/doublehealixprofiel' : '/doublehealixprofile';

    return this.dhConfig
      .listPublicLandings()
      .then((rows) => {
        const enabled = (rows || []).some((r) => r.level === level);
        if (enabled) return true;
        return this.router.parseUrl(landingUrl);
      })
      .catch(() => this.router.parseUrl(landingUrl));
  }
}
